module.exports = __webpack_public_path__ + "img/Kettenbagger.7e28959e.svg";